import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/axios';

const statusColor = {
  placed: 'bg-amber-100 text-amber-900 border border-amber-300',
  confirmed: 'bg-blue-100 text-blue-900 border border-blue-300',
  processing: 'bg-indigo-100 text-indigo-900 border border-indigo-300',
  shipped: 'bg-purple-100 text-purple-900 border border-purple-300',
  delivered: 'bg-emerald-100 text-emerald-900 border border-emerald-300',
  cancelled: 'bg-rose-100 text-rose-900 border border-rose-300',
  returned: 'bg-stone-100 text-stone-900 border border-stone-300',
};

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/orders/my').then((res) => setOrders(res.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="max-w-5xl mx-auto px-4 py-20 text-center text-[#8A796C]">Loading your orders...</div>;

  return (
    <div className="bg-[#FAF8F5] min-h-screen text-[#2B1810] py-10">
      <div className="max-w-5xl mx-auto px-4">
        <h1 className="font-heading text-3xl font-bold text-[#2B1810] mb-8">
          My Orders & Tracking
        </h1>

        {orders.length === 0 ? (
          <div className="bg-white border border-[#E8DFD8] rounded-lg p-10 text-center space-y-3">
            <p className="text-sm text-[#8A796C]">You haven't placed any orders yet.</p>
            <div>
              <Link to="/shop" className="bg-[#C49A45] hover:bg-[#B08736] text-white font-bold text-xs uppercase tracking-widest px-6 py-2.5 rounded shadow inline-block">
                EXPLORE CATALOG
              </Link>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            {orders.map((o) => (
              <Link 
                to={`/orders/${o._id}`} 
                key={o._id} 
                className="bg-white border border-[#E8DFD8] rounded-lg p-5 flex items-center justify-between hover:shadow-md transition-all block"
              >
                <div>
                  <p className="font-heading text-base font-bold text-[#2B1810]">{o.orderNumber}</p>
                  <p className="text-xs text-[#8A796C] mt-0.5">
                    Placed on {new Date(o.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })} • {o.items.length} item(s)
                  </p>
                </div>

                <div className="flex items-center gap-6">
                  <span className="font-bold text-[#2B1810] text-base">₹{o.totalAmount.toFixed(2)}</span>
                  <span className={`text-xs px-3 py-1 rounded-full font-bold uppercase tracking-wider ${statusColor[o.orderStatus] || 'bg-stone-100'}`}>
                    {o.orderStatus}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
